import React from 'react';
import ReactDatePicker, {
  ReactDatePickerProps,
  registerLocale,
} from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ptBR from 'date-fns/locale/pt-BR';
import './styles.css';
import { FieldError } from 'react-hook-form';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  InputGroup,
  Tooltip,
} from '@chakra-ui/react';
import Icon from '@chakra-ui/icon';
import { BsFillInfoCircleFill } from 'react-icons/all';

registerLocale('ptBR', ptBR);

interface DatepickerProps extends ReactDatePickerProps {
  isClearable?: boolean;
  onChange: (date: Date) => void;
  selectedDate: Date | undefined;
  showPopperArrow?: boolean;
  isDisabled?: boolean;
  error?: FieldError;
  label?: string;
  required?: boolean;
  helpText?: string;
}

export const Datepicker: React.VFC<DatepickerProps> = ({
  selectedDate,
  onChange,
  isClearable = false,
  showPopperArrow = false,
  isDisabled = false,
  error = null,
  label = '',
  required = false,
  helpText,
  ...props
}) => {
  return (
    <FormControl isInvalid={!!error}>
      {!!label && (
        <FormLabel
          htmlFor="writeUpFile"
          style={{ fontSize: '14px' }}
          display="flex"
        >
          {label}
          {required && <span style={{ color: 'red' }}>&ensp;* </span>}
          {!!helpText && (
            <Tooltip hasArrow label={helpText} bg="black" shouldWrapChildren>
              &ensp;
              <Icon as={BsFillInfoCircleFill} />
            </Tooltip>
          )}
        </FormLabel>
      )}
      <InputGroup>
        <ReactDatePicker
          selected={selectedDate}
          onChange={onChange}
          isClearable={isClearable}
          showPopperArrow={showPopperArrow}
          locale="ptBR"
          dateFormat="P"
          disabled={isDisabled}
          wrapperClassName={error ? 'invalid' : ''}
          {...props}
        />
      </InputGroup>
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};
